import { cn } from "@/lib/utils";

export const initials = (name = "") =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join("") || "?";

const PALETTE = ["bg-brand-charcoal text-white", "bg-brand-grey text-white", "bg-tint-info text-info", "bg-tint-success text-success", "bg-tint-warning text-warning"];

const colourFor = (name = "") => {
  let h = 0;
  for (const ch of name) h = (h * 31 + ch.charCodeAt(0)) % 997;
  return PALETTE[h % PALETTE.length];
};

export const UserAvatar = ({ name, size = "md", className, solid = false, testId = "user-avatar" }) => (
  <span
    className={cn(
      "num inline-flex shrink-0 select-none items-center justify-center rounded-full font-semibold ring-2 ring-card",
      size === "sm" ? "h-7 w-7 text-[10px]" : size === "lg" ? "h-12 w-12 text-sm" : "h-9 w-9 text-xs",
      solid ? "bg-brand-charcoal text-white" : colourFor(name),
      className,
    )}
    title={name}
    data-testid={testId}
    aria-label={name}
  >
    {initials(name)}
  </span>
);

/** Stabla avatarar for tildelte personar. */
export const AvatarStack = ({ users = [], max = 3, size = "sm", className, testId = "avatar-stack" }) => {
  const shown = users.slice(0, max);
  const rest = users.length - shown.length;
  if (!users.length) return null;
  return (
    <span className={cn("inline-flex items-center -space-x-1.5", className)} data-testid={testId}>
      {shown.map((u) => (
        <UserAvatar key={u.id || u.name} name={u.name} size={size} testId={`${testId}-item`} />
      ))}
      {rest > 0 ? (
        <span className={cn("num inline-flex items-center justify-center rounded-full bg-secondary font-semibold text-muted-foreground ring-2 ring-card", size === "sm" ? "h-7 w-7 text-[10px]" : "h-9 w-9 text-xs")}>+{rest}</span>
      ) : null}
    </span>
  );
};
